var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.languages,"item-text":"title","item-value":"abbr","label":_vm.$lang('LANGUAGE'),"clearable":""},model:{value:(_vm.abbr),callback:function ($$v) {_vm.abbr=$$v},expression:"abbr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }